import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const HeaderAdv2 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-7005">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-7006"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-7007">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-7008">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-7009">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-7010">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-7011">
          <div className="text-left" data-id="element-7012">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-7013">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-7014">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-7015">
        <div className="max-w-4xl mx-auto" data-id="element-7016">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-7017">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-7018">
            Endocrinologist Investigates: Does Semaglutide Actually Damage Mental
            Health—And Why Isn't Anyone Warning You?
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-7019">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-7020">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3QGeAdkaxHnkiYL33dUYdV/Tom_Parham.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-7021" />
            </div>
            <div className="flex-1" data-id="element-7022">
              <div className="flex items-center" data-id="element-7023">
                <div className="font-medium text-gray-900 text-lg" data-id="element-7024">
                  By Dr. Tom Parham, MD, FACE
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-7025">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-7026" />
                  <span className="text-xs ml-1 font-medium" data-id="element-7027">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-7028">
                Board-Certified Endocrinologist, 30 Years Clinical Practice
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-7029">
                <div className="flex items-center mr-4" data-id="element-7030">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-7031" />
                  <span data-id="element-7032">14 min read</span>
                </div>
                <div className="flex items-center" data-id="element-7033">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-7034" />
                  <span data-id="element-7035">31,542 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-7036">
            After three decades in endocrinology, I've prescribed thousands of
            medications. But when patients on semaglutide started reporting severe
            depression—and regulatory agencies ignored it—I decided to run a
            16-month investigation. What I discovered will save you sleepless
            nights - and might actually change your life.
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-7037">
            <div className="mb-1 flex items-center" data-id="element-7038">
              <span className="font-medium mr-2" data-id="element-7039">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-7040">
              <span className="font-medium mr-2" data-id="element-7041">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-7042">
        <div className="max-w-4xl mx-auto" data-id="element-7043">
          <div className="sm:flex items-center" data-id="element-7044">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-7045">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3QGeAdkaxHnkiYL33dUYdV/Tom_Parham.jpg" alt="Dr. Tom Parham in medical office" className="w-full rounded-lg shadow-md" data-id="element-7046" />
            </div>
            <div className="sm:w-2/3" data-id="element-7047">
              <p className="text-sm text-gray-700 mb-2" data-id="element-7048">
                <span className="font-bold" data-id="element-7049">Dr. Tom Parham, MD, FACE</span> is a
                board-certified endocrinologist with 30 years of clinical
                experience specializing in diabetes management and metabolic
                disorders. Throughout his career, he has evaluated hundreds of
                pharmaceutical treatments and their long-term effects on
                patients.
              </p>
              <p className="text-sm text-gray-700" data-id="element-7050">
                His investigative work focuses on identifying and solving
                medication side effects that fall through the cracks of official
                approval processes, helping patients achieve health outcomes
                without sacrificing quality of life.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderAdv2;